const IMAGE_MODE = {
    POSTER: 'POSTER',
    THUMB: 'THUMB',
    SIMPLE_LARGE: 'SIMPLE_LARGE',
    THUMB_OVERVIEW: 'THUMB_OVERVIEW',
    THUMB_OVERVIEW_LIVE: 'THUMB_OVERVIEW_LIVE',
    THUMB_BANNER_HERO: 'THUMB_BANNER_HERO',
    NETWORK: 'NETWORK'
}

const THUMB_OR_POSTER = {
    SIMPLE_LARGE: 'THUMB',
    THUMB: 'THUMB',
    POSTER: 'POSTER'
  }

const IMAGE_MODE_RN = {
  POSTER: 'POSTER',
  THUMB: 'THUMB',
  SIMPLE_LARGE: 'SIMPLE_LARGE',
  THUMB_OVERVIEW: 'THUMB_OVERVIEW',
  THUMB_BANNER_HERO: 'THUMB_BANNER_HERO',
  SIMPLE_FEATURE: 'SIMPLE_FEATURE'
}
  

export {IMAGE_MODE,THUMB_OR_POSTER,IMAGE_MODE_RN};